import React, { memo, useCallback } from "react";

import { HStack, Switch, Text } from "@chakra-ui/react";
import colors from "app/colors";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import { isMessageThreadReadOnly } from "modules/utils/Functions";
import { useAuth } from "modules/providers/auth-provider";
import ReadOnlyHelpButton from "modules/_shared/help-buttons/read-only-help-button";

interface IProps {
  draftId: string;
}

const ComposeReadOnlyToggle = ({ draftId }: IProps) => {
  const { me } = useAuth();
  const { draft, isDraftLoaded, setCreateMessageUserIdList } =
    useMessageThreadDraft({ draftId });

  const onReadOnlyToggleClicked = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.stopPropagation();
      e.preventDefault();
      if (!me) return;
      if (e.target.checked) {
        setCreateMessageUserIdList([me.id]);
      } else {
        setCreateMessageUserIdList([]);
      }
    },
    [me, setCreateMessageUserIdList],
  );

  if (!draft || !isDraftLoaded) return null;

  return (
    <HStack spacing={0}>
      <Switch
        size="sm"
        isChecked={isMessageThreadReadOnly(draft)}
        onChange={onReadOnlyToggleClicked}
      />
      <Text fontSize={14} color={colors.gray50} pl={2} m={0}>
        Read-Only
      </Text>
      <ReadOnlyHelpButton />
    </HStack>
  );
};

export default memo(ComposeReadOnlyToggle);
